import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import BimatterViewer from "bimatter-viewer";
import { RootState } from "../../store/store";
interface ModelState {
    model_id: string;
}
interface InitialState {
    viewer: () => BimatterViewer | null;
    models: { [modelID: number]: ModelState };
}

const initialState: InitialState = { viewer: () => null, models: {} };

const slice = createSlice({
    name: "viewer-core",
    initialState,
    reducers: {
        initViewer: (state, action: PayloadAction<() => BimatterViewer>) => {
            state.viewer = action.payload;
        },
        setModel: (
            state,
            action: PayloadAction<{ modelID: number; model_id: string }>
        ) => {
            const viewer = state.viewer();
            if (!viewer) return;
            state.models[action.payload.modelID] = {
                model_id: action.payload.model_id,
            };
        },
    },
});

export default slice.reducer;

export const { initViewer, setModel } = slice.actions;

export const selectViewer = (state: RootState) => state.viewerMain.viewer;
export const selectModels = (state: RootState) => state.viewerMain.models;
